/* global caiprivacy */
import PropTypes from 'prop-types';
import React from 'react';
import { Accordion, AccordionPanel, Button, Glyphicon } from 'reaxl';

/**
 *  Sitemap generates a sitemap in the form of an accordion for mobile devices and columned link sections for larger viewports
 *
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function NonstaticSitemap(_ref) {
  let {
    collapsed = false,
    data = [],
    ...rest
  } = _ref;
  const colNumber = Math.round(12 / data.length);
  const getColumn = column => [].concat(column);
  const renderSitemapItem = (_ref2, index) => {
    let {
      callback,
      text,
      pagetype,
      glyph,
      img,
      ...itemRest
    } = _ref2;
    const handleClick = e => {
      if (callback && typeof caiprivacy !== 'undefined') {
        e.preventDefault();
        callback();
      }
    };
    return /*#__PURE__*/_jsx("li", {
      children: callback ? /*#__PURE__*/_jsx(Button, {
        bsStyle: "text-decorated",
        onClick: handleClick,
        ...itemRest,
        children: text
      }) : /*#__PURE__*/_jsxs("a", {
        ...itemRest,
        children: [text, glyph && /*#__PURE__*/_jsx(Glyphicon, {
          className: "margin-left-2",
          glyph: glyph
        })]
      })
    }, `${itemRest.href || text}/${pagetype}-${index}`);
  };
  const renderSitemapAccordionPanel = column => getColumn(column).map(_ref3 => {
    let {
      title,
      items
    } = _ref3;
    return /*#__PURE__*/_jsx(AccordionPanel, {
      eventKey: title,
      title: title,
      children: /*#__PURE__*/_jsx("ul", {
        className: "list-unstyled text-inverse",
        children: items.map(renderSitemapItem)
      })
    }, title);
  });
  const renderSitemapSection = section => /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("div", {
      className: "text-bold",
      children: section.title
    }), /*#__PURE__*/_jsx("ul", {
      className: "list-unstyled text-inverse",
      children: section.items.map(renderSitemapItem)
    })]
  }, section.title);
  const renderSitemapColumn = (column, index) => /*#__PURE__*/_jsx("div", {
    className: `col col-sm-${colNumber} text-inverse`,
    children: getColumn(column).map(renderSitemapSection)
  }, index);
  const renderAccordion = () => /*#__PURE__*/_jsx(Accordion, {
    bsStyle: "filters",
    children: data.map(renderSitemapAccordionPanel)
  });
  const renderColumns = () => data.map(renderSitemapColumn);
  return /*#__PURE__*/_jsx("div", {
    "data-cmp": "sitemap",
    className: "row",
    ...rest,
    children: collapsed ? renderAccordion() : renderColumns()
  });
}

// propTypes is deprecated by react

export default NonstaticSitemap;